import { type Injectable, module } from 'angular';

export interface NgServiceOptions {
    name: string;
    module?: string;
}

export function NgService(options: string | NgServiceOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    return (serviceClass: Injectable<Function>) => {
        if (typeof options === 'string') {
            module('a9Services').service(options, serviceClass);
        } else {
            const { name, module: moduleOption } = options;
            module(moduleOption || 'a9Services').service(name, serviceClass);
        }
    };
}
